import { v4 as uuidv4 } from 'uuid'

export class Key {
  get(): string {
    return uuidv4()
  }
}

export default new Key()
